import { useFrame, useThree } from '@react-three/fiber';
import * as THREE from 'three';

// This component doesn't render anything itself. It's a helper for calculations.
function TextPositioner({ planetRefs, onPositionsUpdate }) {
  // Get the camera and the underlying WebGL renderer's DOM element (the <canvas>)
  const { camera, gl } = useThree();

  useFrame(() => {
    if (!planetRefs.current || planetRefs.current.length === 0) {
      return;
    }

    // Get the position and size of the canvas on the screen.
    // This is the crucial step that was missing. It accounts for the canvas's
    // own CSS positioning (top, left, transform, etc.).
    const canvasRect = gl.domElement.getBoundingClientRect();

    const positions = planetRefs.current.map(planetApi => {
      if (!planetApi?.group) {
        // Return a default off-screen position if the planet isn't ready
        return { x: -1000, y: -1000 };
      }

      // 1. Get the 3D world position of the planet
      const worldPosition = new THREE.Vector3();
      planetApi.group.getWorldPosition(worldPosition);

      // 2. Project the 3D position to 2D screen space (Normalized Device Coordinates)
      const screenPosition = worldPosition.project(camera);

      // 3. Convert from NDC to ABSOLUTE pixel coordinates on the viewport.
      // We use the canvasRect's dimensions for the conversion and its top/left
      // properties as an offset.
      const x = (screenPosition.x * 0.5 + 0.5) * canvasRect.width + canvasRect.left;
      const y = (-screenPosition.y * 0.5 + 0.5) * canvasRect.height + canvasRect.top;

      return { x, y };
    });
    
    // 4. Call the update function with the correct, absolute coordinates
    onPositionsUpdate(positions);
  });

  return null; // Render nothing
}

export default TextPositioner;
